import React from 'react';
import styled, { css } from 'styled-components';
import { SvgIcon } from '../../components/Icon';
import KubitTooltip from '../../components/KubitTooltip';
import { colors } from '../../config/styles';

interface IProps {
  isActive: boolean;
  onClick?: (ev: React.SyntheticEvent) => void;
}

const Container = styled.div<{ $isActive: boolean }>`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  border-radius: 4px;
  color: rgba(255, 255, 255, 0.8);
  &:hover {
    cursor: pointer;
    background: rgba(255, 255, 255, 0.25);
    color: ${colors.favoriteGoldTitle};
  }
  ${({ $isActive }) =>
    $isActive &&
    css`
      background: rgba(255, 255, 255, 0.1);
      color: ${colors.favoriteGoldTitle};
    `}
`;

const BrowseFavoritesAction = ({ onClick, isActive }: IProps) => (
  <KubitTooltip
    content={'Browsing Favorites'}
    placement="bottom"
    disabled={isActive}
    noOpenDelay={true}
  >
    <Container onClick={onClick} $isActive={isActive}>
      <SvgIcon name="star" width={24} height={24} customFill="currentColor" />
    </Container>
  </KubitTooltip>
);

export default BrowseFavoritesAction;
